// extracted by mini-css-extract-plugin
export var equalColumn = "_gr-0";